import { createContext } from "react";

import { ShopConfig } from "@utils/ssr";

export const defaultContext: {
  mainMenu: ShopConfig["mainMenu"];
  footer: ShopConfig["footer"];
  siteSetting: ShopConfig["siteSetting"];
} = {
  mainMenu: {
    __typename: "Menu",
    items: [],
  },
  footer: {
    id: "1",
    __typename: "Menu",
    items: [],
  },
  siteSetting: {
    socialMedia: [],
    siteCountryName: "Australia",
    shortDateFormat: "DD/MM/YYYY",
  },
};

export const MenuContext = createContext<typeof defaultContext>(defaultContext);

MenuContext.displayName = "MenuContext";
